import React from 'react'
import Lead from 'logic/Lead';
import AvailabilityCheck from 'logic/AvailabilityCheck';
import { NursePaygradeStats } from 'types/interfaces';

export interface GTMCheckStats {
  numTotal: number
  numNurseFound: number
  pctNurseFound: number
}

interface ILeadDetailContext {
  lead?: Lead
  availabilityCheck?: AvailabilityCheck
  paygradeStats?: NursePaygradeStats
  gtmCheckStats: GTMCheckStats
  setLead: (lead?: Lead) => void
  setAvailabilityCheck: (availabilityCheck?: AvailabilityCheck) => void
  setGtmCheckStats: (stats: GTMCheckStats) => void
}

const LeadDetailContext = React.createContext<ILeadDetailContext>({} as ILeadDetailContext)

export default LeadDetailContext